import prolinkApi from '../../assets/images/prolink.png';
import learningShop from '../../assets/images/learningshop.png';
import book4u from '../../assets/images/bookShop.png';
import lms from '../../assets/images/lms.png';
import school from '../../assets/images/School.png';
import spark from '../../assets/images/spark.png';
import cash from '../../assets/images/DevExpress.png';
import cima from '../../assets/images/cima.png';
import chatty from '../../assets/images/{0112EF46-BDDB-4095-9EF2-F6A6AAA225D4}.png';
import tradof from '../../assets/images/WhatsApp Image 2025-08-29 at 14.55.44_85324afb.jpg';
import sanad from '../../assets/images/{1BCF14AE-12F3-4397-881F-40269389A695}.png';
import controls from '../../assets/images/image.png';
import green from '../../assets/images/WhatsApp Image 2025-08-29 at 15.19.26_26797469.jpg';
import dandara from '../../assets/images/WhatsApp Image 2025-08-29 at 15.35.32_457d8cc6.jpg';
import skinet from '../../assets/images/WhatsApp Image 2025-08-29 at 15.58.01_f93c4a54.jpg';
export const projectsData=[
    {
        id:1,
        img:tradof ,
        title:'Tradof',
        category:'FullStack',
        gitHub:'https://github.com/SABRY225/Tradof',
        isHasDemo:false
    },
    {
        id:2,
        img:chatty ,
        title:'Chatty',
        category:'FullStack',
        gitHub:'https://github.com/ahmedkamalyoussef/real_time_chat_app',
        demo:'https://chatty-f.up.railway.app/',
        isHasDemo:true
    },
    {
        id:3,
        img:controls,
        title:'Controls Management System',
        category:'FullStack',
        gitHub:'https://github.com/Dr-Rabi3/CMS-back',
        demo:'',
        isHasDemo:false
    },
    {
        id:4,
        img:green,
        title:'Green economy',
        category:'FullStack',
        // gitHub:'http://greenclub.dandara-alebdaa.com/',
        demo:'http://greenclub.dandara-alebdaa.com/',
        isHasDemo:true
    },
    {
        id:5,
        img:dandara,
        title:'Dandara Alebdaa',
        category:'FullStack',
        gitHub:'',
        demo:'https://dandara-alebdaa.com/',
        isHasDemo:true
    },
    {
        id:6,
        img:book4u ,
        title:'Book4U',
        category:'FullStack',
        gitHub:'https://github.com/KEMO414/Book4U-MVC-Project',
        demo:'http://book4u.runasp.net',
        isHasDemo:true
    },
    {
        id:7,
        img: lms,
        title:'LMS',
        category: 'Backend',
        gitHub:'https://github.com/ahmedkamalyoussef/Cairo-code-LMS',
        demo:'',
        isHasDemo:false
    },
    {
        id:8,
        img:school ,
        title:'School',
        category: 'Backend',
        gitHub:'https://github.com/KEMO414/School',
        demo:'',
        isHasDemo:false
    },
    {
        id:9,
        img:cash ,
        title:'Cashier',
        category:'Desktop' ,
        gitHub:'https://github.com/KEMO414/DevExpress',
        demo:'',
        isHasDemo:false
    },
    {
        id:10,
        img: learningShop,
        title:'Learning Shop',
        category: 'Frontend',
        gitHub:'https://github.com/SABRY225/Learning-Shop',
        demo:'https://dr-rabi3.github.io/Learing-Shop-Web-site-Project-/',
        isHasDemo:true
    },
    {
        id:11,
        img: spark,
        title:'Spark',
        category:'Frontend',
        gitHub:'https://github.com/Ahmed-Nadyy/Spark',
        demo:'',
        isHasDemo:false
    },
    {
        id:12,
        img: prolinkApi,
        title:'ProLink',
        category: 'Backend',
        gitHub:'https://github.com/KEMO414/ProLink.api',
        demo:'',
        isHasDemo:false
    },
    {
        id:13,
        img:cima ,
        title:'Cima',
        category:'Frontend',
        gitHub:'https://github.com/KEMO414/cima-project',
        demo:'https://kemocima.netlify.app/',
        isHasDemo:true
    },
    {
        id:14,
        img:sanad ,
        title:'Sanad',
        category:'Backend',
        gitHub:'https://github.com/ahmedkamalyoussef/sanad.api',
        demo:'',
        isHasDemo:false
    },
    {
        id:15,
        img:skinet,
        title:'Skinet',
        category:'Backend',
        gitHub:'https://github.com/ahmedkamalyoussef/Skinet-Backend',
        demo:'',
        isHasDemo:false
    },
    
]
export const projectsNav=[
    {
        name:'All'
    },
    {
        name:'Backend'
    },
    {
        name:'Frontend'
    },
    {
        name:'FullStack'
    },
    {
        name:'Desktop'
    },
]